import React from 'react';

import styled from '@emotion/styled';

import BookmarkJob from '../../section/dashboard/BookmarkJob';
import CancelBookmarkJob from '../../section/dashboard/CancelBookmarkJob';
import JobsIcon from '../Icons/JobsIcon';
import Img from '../Img/Img';
import {
  extractTextFromHTML,
  truncateText,
  truncateTextByCharacters,
} from '../../utils/utils';
import { useAppSelector } from '../../redux/store';
import { RootState } from '../../redux/store';

interface IJobListCard {
  imgSrc: string;
  institutionName: string;
  jobTitle: string;
  yearsOfExperience: string;
  pay: number;
  onClick?: (...args: any) => void;
  className?: string;
  jobId: string;
  jobDescription?: string;
  guest?: boolean;
}

const JobListCard: React.FC<IJobListCard> = ({
  imgSrc,
  institutionName,
  jobTitle,
  yearsOfExperience,
  pay,
  onClick,
  className,
  jobId,
  jobDescription,
  guest,
}) => {
  const bookmarkMapping = useAppSelector(
    (state: RootState) => state.bookmarkedLocumJobs.bookmarkMapping
  );
  const isBookmarked = bookmarkMapping.some(
    (mapping) => mapping.jobId === jobId
  );

  return (
    <Container className={className} onClick={onClick}>
      <LeftContent>
        <LeftContentHeader>
          <ImageContainer>
            <Img src={imgSrc} alt="logo" />
          </ImageContainer>
          <LeftContentText>
            {' '}
            {(() => {
              const text = extractTextFromHTML(institutionName);
              const first20 = text.slice(0, 10);
              const spaceCount = (first20.match(/ /g) || []).length;
              return spaceCount === 0
                ? truncateTextByCharacters(text, 7)
                : truncateText(text, 2);
            })()}
          </LeftContentText>
        </LeftContentHeader>

        <LeftContentLowerPart>
          <JobCardDescription>
            {jobDescription
              ? (() => {
                  const text = extractTextFromHTML(jobDescription);
                  const first20 = text.slice(0, 20);
                  const spaceCount = (first20.match(/ /g) || []).length;
                  return spaceCount < 2
                    ? truncateTextByCharacters(text, 30)
                    : truncateText(text, 14);
                })()
              : jobTitle}
          </JobCardDescription>
          <LeftContentFooter>
            <JobAgeArea>
              <JobsIcon />
              {yearsOfExperience} year+
            </JobAgeArea>

            <div>{pay?.formatCurrency()}</div>
          </LeftContentFooter>
        </LeftContentLowerPart>
      </LeftContent>

      {!guest && (
        <IconContainer>
          {isBookmarked ? (
            <CancelBookmarkJob jobId={jobId} />
          ) : (
            <BookmarkJob jobId={jobId} />
          )}
        </IconContainer>
      )}
    </Container>
  );
};

export default JobListCard;

const Container = styled.div`
  display: grid;
  grid-template-columns: auto 32px;
  gap: 0.5rem;
  align-items: flex-start;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 0.3125rem;
  padding: 1.25rem;
  height: 12.3rem;
  background-color: white;
  /* border: 2px solid red; */
  position: relative;

  &.cursor-pointer {
    cursor: pointer;
  }

  &.inv.active {
  }

  &.active {
    border: 1px solid #2f80ed;
    // background-color: #edf5ff;
  }
  @media (max-width: 390px) {
    max-width: 22rem;
  }

    @media (max-width: 380px) {
    max-width: 20rem;
  }
`;

const ImageContainer = styled.div`
  width: 40px;
  height: 40px;
  /* border: 2px solid red; */
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 0.38rem;
`;

const JobAgeArea = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;

  & > svg {
    width: 12px;
    height: 12px;
  }
`;

const LeftContentHeader = styled.div`
  display: flex;
  /* border: 2px solid red; */
  align-items: center;
  gap: 0.38rem;
`;

const LeftContentFooter = styled.div`
  display: flex;
  gap: 1.5rem;
  color: ${({ theme }) => theme.palette.greyGrey1};
  font-size: 0.875rem;
  font-weight: 400;
`;

const LeftContentText = styled.div`
  font-size: 1.25rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.blackBlack2};
`;

const LeftContentLowerPart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  height: 100%;
`;

const JobCardDescription = styled.div`
  font-size: 1rem;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};
  word-break: break-all;
  min-width: 17rem;

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

const IconContainer = styled.div`
  // margin-left: auto;
  position: absolute;
  right: 1rem;
  top: 1rem;
`;
